/* eslint-disable */
export async function asyncForEach<T>(
  array: Array<T>, callback: ( item: T, index: number ) => void
) {
  for ( let index = 0; index < array.length; index++ ) {
    await callback( array[index], index );
  }
}